import { render, staticRenderFns } from "./Heading3AfterHeading2.vue?vue&type=template&id=2dc5bf46&"
import script from "./Heading3AfterHeading2.vue?vue&type=script&lang=js&"
export * from "./Heading3AfterHeading2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports